import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import {Col, Container, Row} from "reactstrap"
import { connect } from "react-redux"

//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import CampUnEditorDraft from "./unlayer-editor-draft";
import RsLink from "components/buttons/rsLink";
import { API_URL } from "helpers/app_url";
import { loadCampMasterTemplate  } from "../../store/templates/actions";
import CopyText from "components/buttons/copyBtn";

class campMailEditors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templateName : '',
            design: {},
            id: '',           
            projectId: '',    
            templateId: '',
            backTypeId: null  
        }
        this.handleChange = this.handleChange.bind(this);
        this.exportHtml = this.exportHtml.bind(this);
        this.LoadUnlayerRef = React.createRef();   
    }
    handleChange(event) {
        this.setState({ templateName: event.target.value });
      }

      componentDidMount() {
        const { match } = this.props;
        const { templateId } = match.params;
        this.setState({templateId});
        this.autoSaveInterval = setInterval(() => {
          this.saveasdraft();
        }, 5000);
    }
    componentWillUnmount() {
      if (this.autoSaveInterval) {
        clearInterval(this.autoSaveInterval);
      }
  }
    
 exportHtml = () => {
   
        if (this.LoadUnlayerRef && this.LoadUnlayerRef.current) {
      
          this.LoadUnlayerRef.current.exportHtml((htmlContent) => {
            
            //
            const payload = {
              
                 id: this.props.campData.id,
                agentEmailCampaignId:this.props.campData.agentEmailCampaignId,
                emailCampaignTypeId: this.props.campData.templateType,
                emailCampaignTemplateId: this.props.campData.id,
                emailCampaignCss: null,
                emailCampaignFullContent: JSON.stringify(htmlContent.design),
                agentId: parseInt(localStorage.getItem('userId')),
                isActive: true,
                emailCampaignSubject: this.props.campData.templateTitle,
                emailCampaignContent: htmlContent.html,
                emailCampaignListIds: null,
                emailTargetTypeId: 0,
                emailCampaignTitle: this.props.campData.templateTitle,
                emailTargetSubTypeId: 0,
                emailTargetFilter: null,
                emailCampaignSchedule: "0001-01-01T00:00:00", // represents a default/unset datetime
                emailCampaignSendStatus: "Pending",
                emailCampaignPublishStatus: "Draft"
            };
              const obj = JSON.parse(localStorage.getItem("authUser"));
              const token = obj.resultData.bearerToken;
              const str = 'Bearer ' + token;
              const headers = {
                  'Content-Type': 'application/json',
                  'Authorization': str
              }
              
              toast.loading("Please wait...");
              axios.put(`${API_URL}AgentEmailCampaign/updateAgentEmailCampaignSaveDraft`, payload, {
                  headers: headers
                })
                .then((response) => {

                    toast.dismiss();

                    
                  
                    this.props.history.push('/campaign/mail-send/' + response.data.agentEmailCampaign.id + '/' + response.data.agentEmailCampaign.agentEmailCampaignId);
                })
                .catch((error) => {
                 
                }) 
            });
           

        }
      };
    

      

      saveasdraft = () => {
        if (this.LoadUnlayerRef && this.LoadUnlayerRef.current) {
          this.LoadUnlayerRef.current.exportHtml((htmlContent) => {
           
            const payload = {
                id: this.props.campData.id,
                agentEmailCampaignId:this.props.campData.agentEmailCampaignId,
                emailCampaignTypeId: this.props.campData.templateType,
                emailCampaignTemplateId: this.props.campData.id,
                emailCampaignCss: null,
                emailCampaignFullContent: JSON.stringify(htmlContent.design),
                agentId: parseInt(localStorage.getItem('userId')),
                isActive: true,
                emailCampaignSubject: this.props.campData.templateTitle,
                emailCampaignContent: htmlContent.html,
                emailCampaignListIds: null,
                emailTargetTypeId: 0,
                emailCampaignTitle: this.props.campData.templateTitle,
                emailTargetSubTypeId: 0,
                emailTargetFilter: null,
                emailCampaignSchedule: "0001-01-01T00:00:00", // represents a default/unset datetime
                emailCampaignSendStatus: "Pending",
                emailCampaignPublishStatus: "Draft"
            };
            // 
            const obj = JSON.parse(localStorage.getItem("authUser"));
            const token = obj.resultData.bearerToken;
            const str = 'Bearer ' + token;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': str
            }
            //toast.loading("Please wait...");
            axios.put(`${API_URL}AgentEmailCampaign/updateAgentEmailCampaignSaveDraft`, payload, {
                    headers: headers
                  })
                  .then((response) => {
                    const emailCampaignTypeId = response?.data?.agentEmailCampaign?.emailCampaignTypeId;

                     this.setState({
                        backTypeId: emailCampaignTypeId || null
                    }); 
                    
                  })
                  .catch((error) => {
                   
                  }) 
          });
        }
      };

    

      sendPreview = () => {
       
         
          if (this.LoadUnlayerRef && this.LoadUnlayerRef.current) {
            this.LoadUnlayerRef.current.exportHtml((htmlContent) => {
            const payload = {
              'agentId': parseInt(localStorage.getItem("userId")),
              'emailCampaignFullContent': JSON.stringify(htmlContent.html),
              'emailCampaignProjectId': parseInt(this.props.projectData.id),
              'emailCampaignTemplateId': parseInt(this.state.templateId),
              'emailCampaignTitle' : 'Preview Email',
              'emailCampaignSubject' : 'Preview Email',
              'emailCampaignContent' : htmlContent.html,
              'emailCampaignCss' : '',
              //'emailCampaignPublishStatus' : 'draft',
              'IsActive':true
            };
            const obj = JSON.parse(localStorage.getItem("authUser"));
            const token = obj.resultData.bearerToken;
            const str = 'Bearer ' + token;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': str
            }
            toast.loading("Please wait...");
            axios.post(`${API_URL}ProjectEmailCampaign/previewprojectemailcampaign`, payload, {
                    headers: headers
                  })
                  .then((response) => {
                    toast.dismiss();
                    toast.success("Preview Mail Send");
                    //history.push('/pre-construction/my-project');
                    
                  })
                  .catch((error) => {
                   
                  }) 
          });
        }
      };
    

      

  
    

   
    render() {
     
       const { campData } = this.props;
        //
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Email Editor | Realty Space</title>
                    </MetaTags>
                    <ToastContainer autoClose={2000} />
                    <Container fluid>
                        {/* Render Breadcrumb */}
                    <div>
                  
                    <span className="float-start mb20">
                        <RsLink className="btn btn-light btn-md" iconClass="bx bx-arrow-back" to={`/campaign-detail/`+ this.state.backTypeId}>
                            Back
                        </RsLink>
                
                    </span>
                    <span className="float-end">
            {/* <button
                type="button"
                className="btn btn-warning w-md me-2"
                
                onClick={this.saveasdraft}
            >
                                 Save as Draft
                                </button>{" "} */}
                                <button
                                  type="button"
                                  className="btn btn-success w-md me-2"
                                
                                  onClick={this.sendPreview}
                                >
                                  Send Preview Mail
                                </button>{" "}
            <button onClick={this.exportHtml}
              
              className="btn btn-primary w-md me-2"
             
            >
              Save & Continue
            </button>
            </span>
            <div className="clearfix w-100"></div>
          
                    <CampUnEditorDraft  ref={this.LoadUnlayerRef} />
                    </div>
                    </Container>
                </div>
            </React.Fragment>
        )
    }



}
campMailEditors.propTypes = {
    t: PropTypes.any,
    history:PropTypes.object,
    match:PropTypes.object,
    loading: PropTypes.bool,
    onLoadCampMasterTemplate:PropTypes.func,
    projectData:PropTypes.object,
    emailTemplateTitle:PropTypes.object,
    campData:PropTypes.object

}
const mapStateToProps = ({ Project, Template }) => (
    {
      campData:Template.campData,
      loading:Project.loading
  
    })
  const mapDispatchToProps = dispatch => ({
   onLoadCampMasterTemplate:(templateId, agentId)  => dispatch(loadCampMasterTemplate(templateId, agentId))
  });
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(campMailEditors))